import { Button, Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

export default function ModalDates({ show, onHide, onClick }) {
  const { t } = useTranslation()

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>{t('event.dates_modal_title')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{t('event.dates_modal_message')}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {t('buttons.cancel')}
        </Button>
        <Button onClick={onClick}>{t('buttons.edit')}</Button>
      </Modal.Footer>
    </Modal>
  )
}
